module.exports = __webpack_public_path__ + "static/media/omg.3a83b572.svg";